import { gql } from "@apollo/client";
import { PolicyVehicleExemptionSummary, policyVehicleExemptionSummaryFragment } from "../fragments";

export const END_VEHICLE_EXEMPTION = gql`
  mutation EndVehicleExemption($policyVehicleExemptionId: uuid!, $endAt: timestamptz!) {
    endPolicyVehicleExemption: end_policy_vehicle_exemption(
      policy_vehicle_exemption_id: $policyVehicleExemptionId
      end_at: $endAt
    ) {
      policyVehicleExemption: policy_vehicle_exemption {
        ...policyVehicleExemptionSummaryFragment
      }
    }
  }
  ${policyVehicleExemptionSummaryFragment}
`;

export interface EndVehicleExemptionVars {
  policyVehicleExemptionId: string;
  endAt: Date;
}

export interface EndVehicleExemptionData {
  endPolicyVehicleExemption: {
    policyVehicleExemption: PolicyVehicleExemptionSummary;
  };
}

export default END_VEHICLE_EXEMPTION;
